<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<orbit-aside-v2 [hasOutcomeActions]="true">
	<div orbitAsideHeader [ngClass]="asideClass" class="customer-form__header">
		<h3>Your Details</h3>
	</div>
	<div orbitAsideBody [formGroup]="dataForm" class="aside-content customer-form__body">
		<concurrency-error [message]="concurrencyErrorMessage" (reloadRequested)="loadFormDetails()"></concurrency-error>
		<div class="form-row">
			<div class="form-col">
				<mat-form-field>
					<mat-label>First Name</mat-label>
					<input formControlName="firstName" matInput />
					<mat-error *ngIf="firstName.touched && firstName.errors?.required"> First Name is required
					</mat-error>
					<mat-error *ngIf="firstName.touched && firstName.errors?.maxlength"> First Name must be no more than
						50 characters </mat-error>
					<mat-error *ngIf="firstName.touched && firstName.errors?.pattern"> First Name must be a correctly
						formatted person's name </mat-error>
				</mat-form-field>
			</div>
			<div class="form-col">
				<mat-form-field>
					<mat-label>Last Name</mat-label>
					<input formControlName="lastName" matInput />
					<mat-error *ngIf="lastName.touched && lastName.errors?.required"> Last Name is required </mat-error>
					<mat-error *ngIf="lastName.touched && lastName.errors?.maxlength"> Last Name must be no more than 50
						characters </mat-error>
					<mat-error *ngIf="lastName.touched && lastName.errors?.pattern"> Last Name must be a correctly
						formatted person's name </mat-error>
				</mat-form-field>
			</div>
		</div>

		<div>
			<mat-form-field>
				<mat-label>Email</mat-label>
				<input formControlName="email" matInput />
				<mat-error *ngIf="email.touched && email.errors?.required"> Email is required </mat-error>
				<mat-error *ngIf="email.touched && email.errors?.maxlength"> Email must be no more than 254 characters
				</mat-error>
				<mat-error *ngIf="email.touched && email.errors?.pattern && !email.errors?.maxlength"> Email must be a
					correctly formatted email address </mat-error>
			</mat-form-field>
		</div>

		<div class="form-row">
			<div class="form-col">
				<mat-form-field>
					<mat-label>Telephone</mat-label>
					<input formControlName="phoneNumber" matInput />
					<mat-error *ngIf="phoneNumber.touched && phoneNumber.errors?.required"> Telephone is required
					</mat-error>
					<mat-error *ngIf="phoneNumber.touched && phoneNumber.errors?.maxlength"> Telephone must be no more
						than 15 characters </mat-error>
					<mat-error
						*ngIf="phoneNumber.touched && phoneNumber.errors?.pattern && !phoneNumber.errors?.maxlength">
						Telephone must be a correctly formatted phone number </mat-error>
				</mat-form-field>
			</div>
			<div class="form-col"></div>
		</div>

		<div class="form-row">
			<div class="form-col">
				<mat-form-field>
					<mat-label>Address Line 1</mat-label>
					<input formControlName="addressLine1" matInput />
					<mat-error *ngIf="addressLine1.touched && addressLine1.errors?.required"> Address Line 1 is required
					</mat-error>
					<mat-error *ngIf="addressLine1.touched && addressLine1.errors?.maxlength"> Address Line 1 must be no
						more than 100 characters </mat-error>
				</mat-form-field>
			</div>
			<div class="form-col">
				<mat-form-field>
					<mat-label>Address Line 2</mat-label>
					<input formControlName="addressLine2" matInput />
					<mat-error *ngIf="addressLine2.touched && addressLine2.errors?.maxlength"> Address Line 2 must be no
						more than 100 characters </mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="form-row">
			<div class="form-col">
				<mat-form-field>
					<mat-label>Address Line 3</mat-label>
					<input formControlName="addressLine3" matInput />
					<mat-error *ngIf="addressLine3.touched && addressLine3.errors?.maxlength"> Address Line 3 must be no
						more than 100 characters </mat-error>
				</mat-form-field>
			</div>
			<div class="form-col">
				<mat-form-field>
					<mat-label>Address Line 4</mat-label>
					<input formControlName="addressLine4" matInput />
					<mat-error *ngIf="addressLine4.touched && addressLine4.errors?.maxlength"> Address Line 4 must be no
						more than 100 characters </mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="form-row">
			<div class="form-col">
				<mat-form-field>
					<mat-label>Town</mat-label>
					<input formControlName="town" matInput />
					<mat-error *ngIf="town.touched && town.errors?.required"> Town is required </mat-error>
					<mat-error *ngIf="town.touched && town.errors?.maxlength"> Town must be no more than 60 characters
					</mat-error>
				</mat-form-field>
			</div>
			<div class="form-col">
				<mat-form-field>
					<mat-label>County</mat-label>
					<input formControlName="county" matInput />
					<mat-error *ngIf="county.touched && county.errors?.maxlength"> County must be no more than 25
						characters </mat-error>
				</mat-form-field>
			</div>
		</div>

		<div class="form-row">
			<div class="form-col">
				<mat-form-field>
					<mat-label>Postcode</mat-label>
					<input formControlName="postcode" matInput uppercaseInput />
					<mat-error *ngIf="postcode.touched && postcode.errors?.required"> Postcode is required </mat-error>
					<mat-error *ngIf="postcode.touched && postcode.errors?.maxlength"> Postcode must be no more than 8
						characters </mat-error>
					<mat-error *ngIf="postcode.touched && postcode.errors?.pattern && !postcode.errors?.maxlength">
						Postcode must be a correctly formatted postcode </mat-error>
				</mat-form-field>
			</div>
			<div class="form-col"></div>
		</div>

		<div>
			<div>
				<mat-label class="no-formfield">THE ORGANISER OF THIS EVENT, [EVENT NAME], WOULD LIKE TO SEND YOU
					INFORMATION ABOUT THEIR UPCOMING EVENTS BY EMAIL</mat-label>
				<boolean-radio-group formControlName="orbitContactPreference"
					trueLabel="Yes please, I would like to receive this information"
					falseLabel="No thanks, I would prefer not to receive this information" [buttonsHorizontal]="false">
				</boolean-radio-group>
			</div>
		</div>

		<div>
			<div>
				<mat-label class="no-formfield">ORBIT TICKETS LIMITED WOULD LIKE TO KEEP YOU INFORMED ABOUT UPCOMING
					EVENTS, INCLUDING EXCLUSIVE PRESALES AND ARTIST TOUR ANNOUNCEMENTS BY EMAIL</mat-label>
				<boolean-radio-group formControlName="organiserContactPreference"
					trueLabel="Yes please, I would like to receive this information"
					falseLabel="No thanks, I would prefer not to receive this information" [buttonsHorizontal]="false">
				</boolean-radio-group>
			</div>
		</div>
	</div>
	<div orbitAsideFooter class="aside-content customer-form__footer flex-layout-row flex-layout-gap-10px">
		<button mat-raised-button (click)="save()" color="primary">{{ saveText }}</button>
		<button mat-raised-button (click)="cancel()">Cancel</button>
	</div>
</orbit-aside-v2>
